module.exports = __webpack_public_path__ + "media/images/down_arrow-fe9d50e3.gif";